import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

import ImageLight from '../assets/img/login-dark1.png'
import ImageDark from '../assets/img/login-dark1.png'
import { Label, Input, Button } from "@windmill/react-ui";
import { changePassword } from "../services/forgotPasswordService";
import toast from "react-hot-toast";

function ChangePassword() {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const newPassword = watch("newPassword");
  const [isLoading, setisLoading] = useState(false);

  const onSubmit = async (data) => {
    const email = localStorage.getItem("email");
    const otp = localStorage.getItem("otp");
    setisLoading(true);
    try {
      const response = await changePassword({
        email,
        otp,
        newPassword: data?.newPassword,
      });
      if (response.status == "success") {
        toast.success(response?.message);
        localStorage.removeItem("email")
        localStorage.removeItem("otp")
        window.location.href = "/#/login"
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setisLoading(false);
    }
  };

  return (
    <div className="flex items-center min-h-screen p-6 bg-gray-50 dark:bg-gray-900">
      <div className="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl dark:bg-gray-800">
        <div className="flex flex-col overflow-y-auto md:flex-row">
          <div className="h-32 md:h-auto md:w-1/2">
            <img
              aria-hidden="true"
              className="object-cover w-full h-full dark:hidden"
              src={ImageLight}
              alt="Office"
            />
            <img
              aria-hidden="true"
              className="hidden object-cover w-full h-full dark:block"
              src={ImageDark}
              alt="Office"
            />
          </div>
          <main className="flex flex-col gap-4 items-center justify-center p-6 sm:p-12 md:w-1/2">
            <div className="w-full">
              <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                Change Password
              </h1>

              <form onSubmit={handleSubmit(onSubmit)}>
                <Label>
                  <span>New Password</span>
                  <Input
                    type="password"
                    className="mt-1"
                    placeholder="Enter new password"
                    {...register("newPassword", {
                      required: "New password is required",
                    })}
                  />
                  {errors.newPassword && (
                    <p className="text-red-500 text-xs">
                      {errors.newPassword.message}
                    </p>
                  )}
                </Label>

                <Label className="mt-4">
                  <span>Confirm Password</span>
                  <Input
                    type="password"
                    className="mt-1"
                    placeholder="Confirm new password"
                    {...register("confirmPassword", {
                      required: "Confirm password is required",
                      validate: (value) =>
                        value === newPassword || "Passwords do not match",
                    })}
                  />
                  {errors.confirmPassword && (
                    <p className="text-red-500 text-xs">
                      {errors.confirmPassword.message}
                    </p>
                  )}
                </Label>

                <Button
                  type="submit"
                  className="mt-4 disabled:cursor-not-allowed disabled:opacity-60"
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "Change password"}
                </Button>
              </form>
            </div>
            <Link
              to={"/login"}
              className="text-xs text-blue-500 text-center w-full"
            >
              Back to Login
            </Link>
          </main>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
